app.controller("StudentStatesController", ["$scope", "StaticData", "Students", "student", "$uibModalInstance",
    function ($scope,StaticData, Students, student, $uibModalInstance) {
        $scope.statesMap = {};
        $scope.student = student;
        $scope.statuses = [];

        Students.stateList(student._id).then(function (data) {
            $scope.studentStates = data;
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = states;
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        $scope.log = function (st) {
            console.log(st)
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);